module.exports = __webpack_public_path__ + "img/Referra_transparent_white_270x63.f57bd490.png";